function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { action, computed, extendObservable } from 'mobx';
export const AVAILABILITY_TYPES = {
  CLIENT: 'CLIENT',
  EXPERT: 'EXPERT',
  BOTH: 'BOTH'
};

function getType(availabilityData) {
  if (availabilityData.projectId) {
    return AVAILABILITY_TYPES.CLIENT;
  } else {
    return AVAILABILITY_TYPES.EXPERT;
  }
}

function prepareData(availabilityData) {
  const type = availabilityData.type || getType(availabilityData);
  const data = { ...availabilityData,
    type
  };

  if (data.type === AVAILABILITY_TYPES.CLIENT) {
    data.clientAvailabilityId = data.id;
  } else {
    data.expertAvailabilityId = data.id;
  }

  return data;
}

class Availability {
  constructor(availabilityData, store) {
    _defineProperty(this, "remove", action(() => {
      if (this.type === 'BOTH' || this.type === 'CLIENT') {
        const entry = this.store.clientAvailabilities.find(av => av.clientAvailabilityId === this.clientAvailabilityId);
        this.store && this.store.clientAvailabilities.remove(entry);
      }

      if (this.type === 'BOTH' || this.type === 'EXPERT') {
        const entry = this.store.expertAvailabilities.find(av => av.expertAvailabilityId === this.expertAvailabilityId);
        this.store && this.store.expertAvailabilities.remove(entry);
      }
    }));

    _defineProperty(this, "toJS", () => {
      return {
        type: this.type,
        startTime: this.startTime,
        endTime: this.endTime
      };
    });

    this.store = null;
    this.type = null;
    this.clientAvailabilityId = null;
    this.expertAvailabilityId = null;
    this.startTime = null;
    this.endTime = null;
    extendObservable(this, {
      loading: false,
      error: null,
      store: store,
      ...prepareData(availabilityData),
      typeLabel: computed(() => {
        if (this.type === 'EXPERT') return 'Expert available';
        if (this.type === 'CLIENT') return 'Client available';
        if (this.type === 'BOTH') return 'Both available';
        return '';
      })
    });
  }

}

export default Availability;